import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Channel, STORE_URL } from '@insite-store360/shared';
import { catchError, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelserviceService {
  // private readonly CHANNEL_API = `${environment.apiUrl}`;
  // private readonly CHANNEL_API = `${environment.apiUrl}`;
  private readonly CHANNEL_API = `${STORE_URL}`;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  /**
   * Api for getAll Account Infon
   */

  public channelGetAll(
    pageIndex: number,
    pageSize: number,
    searchFilter?: string,
    status: number = 2
  ): Observable<any> {
    if (searchFilter) {
      return this.http
        .get<any>(
          `${this.CHANNEL_API}/channel/getAll?pageIndex=${pageIndex}&pageSize=${pageSize}&searchFilter=${searchFilter}&status=${status}`
        ) // Include the data payload here
        .pipe(catchError(this.errorHandler.handleError));
    } else {
      return this.http
        .get<any>(
          `${this.CHANNEL_API}/channel/getAll?pageIndex=${pageIndex}&pageSize=${pageSize}&status=${status}`
        ) // Include the data payload here
        .pipe(catchError(this.errorHandler.handleError));
    }
  }
  /**
   * Sends a POST request to the server to add a new store's information.
   * @param channelDetails - The store data to be added
   * @returns
   */
  public addChannelData(channelDetails: {
    id: number;
    name: string;
  }): Observable<any> {
    return this.http
      .post<any>(`${this.CHANNEL_API}/channel/save`, channelDetails)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public updateChannel(channelDetails: {
    id: number;
    name: string;
  }): Observable<any> {
    return this.http
      .put<any>(`${this.CHANNEL_API}/channel/update`, channelDetails)
      .pipe(catchError(this.errorHandler.handleError));
  }
  /**
   * Toggel status.
   * @param id - The unique identifier of the status
   */

  updateToggleChannelStatus(id: number): Observable<any> {
    return this.http
      .put<any>(`${this.CHANNEL_API}/channel/changeStatus/${id}`, null)
      .pipe(catchError(this.errorHandler.handleError));
  }
  /**
   * Deletes a channel from the server.
   * @param id - The unique identifier of the channel to be deleted.
   * @returns An Observable that emits a confirmation message upon successful deletion.
   */
  public deleteChannel(id: number): Observable<string> {
    return this.http
      .delete<string>(`${this.CHANNEL_API}/channel/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // to get the dropdown for regions and country in text in excel

  public downloadExcelTemplate() {
    return this.http
      .get(`${this.CHANNEL_API}/channel/downloadExcelTemplate`, {
        responseType: 'blob',
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  // **
  //  * Imports a list of channel into the server
  public importChannelData(data: any): Observable<Channel[]> {
    return this.http
      .post<Channel[]>(`${this.CHANNEL_API}/channel/importChannelData`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // to get active channel status
  public getAllActiveChannel(searchFilter?: string): Observable<any> {
    let queryParams = new HttpParams();
    if (searchFilter) {
      queryParams = queryParams.set('searchFilter', searchFilter);
    }
    return this.http
      .get<any>(`${this.CHANNEL_API}/channel/getAllActive`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * export channels
   * @returns blob
   */
  public exportChannels(): Observable<Blob> {
    const columns: string[] = ['Name']; //export needed columns
    // const columns:string[] = []; //export all columns

    return this.http
      .post<Blob>(
        `${this.CHANNEL_API}/channel/downloadExcelReport`,
        { columns },
        {
          responseType: 'blob' as 'json',
        }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }
}
